import { atom } from "jotai";
import { RouterProvider, createHashRouter, redirect } from "react-router-dom";
import Root from "./routes/root";
import "./extensions/yup-extensions";
import HandleNewsletter from "./routes/HandleNewsletter";
import SubscriptionStarted from "./routes/SubscriptionStarted";
import SubscriptionCancelled from "./routes/SubscriptionCancelled";

// Flow guard and router setup
const FLOW_KEY = "newsletter-flow";

const navigationEntry = performance.getEntriesByType("navigation")[0] as
  | PerformanceNavigationTiming
  | undefined;

const isReload = navigationEntry?.type === "reload";

if (isReload) {
  sessionStorage.removeItem(FLOW_KEY);
}

function startFlow() {
  sessionStorage.setItem(FLOW_KEY, "active");
  return null;
}

function isFlowActive() {
  return sessionStorage.getItem(FLOW_KEY) === "active";
}

function clearFlow() {
  sessionStorage.removeItem(FLOW_KEY);
  return null;
}

function requireActiveFlow() {
  return isFlowActive() ? null : redirect("/");
}

const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <HandleNewsletter />,
        loader: () => {
          return startFlow();
        },
      },
      {
        path: "prenumeration-startad",
        element: <SubscriptionStarted />,
        loader: async () => {
          const access = requireActiveFlow();
          if (access) return access;

          clearFlow();
          return null;
        },
      },
      {
        path: "prenumeration-avslutad",
        element: <SubscriptionCancelled />,
        loader: async () => {
          const access = requireActiveFlow();
          if (access) return access;

          clearFlow();
          return null;
        },
      },
    ],
  },
]);

const pagePaths =
  router?.routes[0]?.children?.map((child) => child.path).filter(Boolean) || [];

export const pageCountAtom = atom({ pagePaths });

function App() {
  return <RouterProvider router={router} />;
}

export default App;
